export const CREATE_CHANTIER = "CREATE_CHANTIER";
export const RETRIEVE_CHANTIERS = "RETRIEVE_CHANTIERS";
export const UPDATE_CHANTIER = "UPDATE_CHANTIER";
export const DELETE_CHANTIER = "DELETE_CHANTIER";
export const DELETE_ALL_CHANTIERS = "DELETE_ALL_CHANTIERS";

